import { AppUser } from '@contexts/app/types';
import { User } from '@services/resources/users/old/types';

export const modelUserData = ({
  id,
  email,
  firstName,
  lastName,
  primaryRole,
  roles,
  tenant,
  menuAccess,
  homePage,
  displayOptions,
  displayOptionsSettings,
}: User): AppUser => ({
  id,
  email,
  firstName: firstName || '',
  lastName: lastName || '',
  primaryRole,
  roles,
  tenant,
  menuAccess,
  homePage,
  displayOptionsSettings,
  displayOptions,
});
